import * as React from 'react';

import {StarRating} from '../../features/StarRating';
import {Text} from './Text';

interface IRatingCard {
  title?: string;
  starCount: number;
  reviewer?: string;
  starColor?: 'black' | 'yellow';
  children: React.ReactNode;
}

export const RatingCard = ({
  title,
  starCount,
  reviewer,
  starColor = 'yellow',
  children,
}: IRatingCard) => {
  return (
    <div
      className={`rounded-[1.5rem] text-black p-6 bg-background text-center`}>
      {!!title && (
        <p className="text-largebodymob lg:text-largebody font-title pb-2">
          {title}
        </p>
      )}
      <div className={`flex pb-2 gap-1 justify-center`}>
        <StarRating
          rating={starCount}
          starColor={starColor}
          showNumber={false}
        />
      </div>

      <Text as="div" variant="SmallBody" className="overflow-hidden">
        {children}
        {!!reviewer && <p className="pt-3 font-semibold">{reviewer}</p>}
      </Text>
    </div>
  );
};
